import React, {
  ComponentType,
  FunctionComponent,
  PropsWithChildren,
} from 'react';
import { RegisterOptions } from 'react-hook-form/dist/index.ie11';
import { useRequiredForAutoInvoicing } from 'src/components/enterprise/features/Corporate/components/Form/hooks/useRequiredForAutoInvoicing';

export function withRequiredForAutoInvoicing<
  T extends { rules?: RegisterOptions; name: string }
>(
  Component: ComponentType<T>,
  validationMessage: string
): FunctionComponent<T> {
  return function WithRequiredForAutoInvoicingComponent({
    rules,
    name,
    ...otherProps
  }: PropsWithChildren<T>): JSX.Element {
    const autoInvoicingRules = useRequiredForAutoInvoicing(
      validationMessage,
      name
    );

    // Combine the rules from props and autoInvoicingRules
    const combinedRules = { ...rules, ...autoInvoicingRules };

    return (
      <Component {...(otherProps as T)} name={name} rules={combinedRules} />
    );
  };
}
